<app-appointment-setup-popup #appointmentPopup></app-appointment-setup-popup>
<app-meeting-setup-popup #meetingPopup></app-meeting-setup-popup>
<app-administration-popup #adminPopup></app-administration-popup>
<button class="calendar-menu-toggle" (click)="SideMenuToggle()">=</button>
<div class="page-container">
  <div class="scheduler-page">
    <div class="demo-toolbar">
      <bryntum-button class="bryntum-button"
                      text="Full View"
                      tooltip="Toggles side bar to view all members"
                      icon="b-fa b-fa-bars"
                      (onClick)="onToggle()"></bryntum-button>
      <span class="date-display">{{ DateToDisplay }}</span>
      <div class="view-buttons" *ngIf="!isTabletOrSmaller">
        <bryntum-button *ngIf="viewType !== 'day'"
                        text="Day"
                        tooltip="Switch to day view"
                        (onClick)="changeViewType('day')"></bryntum-button>
        <bryntum-button *ngIf="viewType !== 'week'"
                        text="Week"
                        tooltip="Switch to week view"
                        (onClick)="changeViewType('week')"></bryntum-button>
        <bryntum-button *ngIf="viewType !== 'month'"
                        text="Month"
                        tooltip="Switch to month view"
                        (onClick)="changeViewType('month')"></bryntum-button>
        <!--<bryntum-button *ngIf="viewType !== 'day'"
                        text="Scheduler"
                        tooltip="Switch to scheduler view"
                        (onClick)="changeViewType('scheduler')"></bryntum-button>-->
      </div>
    </div>
    <div class="scheduler-container">
      <!-- Sidebar -->
      <div class="sidebar" *ngIf="fullScheduler">
        <div class="row text-center" *ngIf="viewType != 'day' && !isTabletOrSmaller">
          <div class="col-md-4">
            <div class="btn-group">
              <div class="btn btn-primary"
                   mwlCalendarPreviousView
                   [view]="view"
                   [(viewDate)]="viewDate"
                   (viewDateChange)="closeOpenMonthViewDay()">
                Previous
              </div>
              <div class="btn btn-outline-secondary"
                   mwlCalendarToday
                   [(viewDate)]="viewDate"
                   (click)="ResetDate()">
                Today
              </div>
              <div class="btn btn-primary"
                   mwlCalendarNextView
                   [view]="view"
                   [(viewDate)]="viewDate"
                   (viewDateChange)="closeOpenMonthViewDay()">
                Next
              </div>
            </div>
          </div>
          <hr />
        </div>
        <ng-container *ngIf="userSession.RoleID == 1">
          <div class="branch-dropdown-container">
            <label for="province" class="branch-label">Province</label>
            <select id="province" [(ngModel)]="selectedProvinceID" (change)="onProvinceSelect($event)" class="branch-select">
              <option value="0" disabled selected>Select a province</option>
              <option *ngFor="let province of provinces" [value]="province.ID">{{ province.Type }}</option>
            </select>
          </div>
          <div class="branch-dropdown-container" *ngIf="selectedProvinceID">
            <label for="branch" class="branch-label">Branch</label>
            <select id="branch" [(ngModel)]="selectedBranch" (change)="onBranchSelect($event)" class="branch-select">
              <option value="0" disabled selected>Select a branch</option>
              <option *ngFor="let branch of branches" [value]="branch.ID">{{ branch.BranchName }}</option>
            </select>
          </div>
        </ng-container>
        <br />
        <!-- Date Picker -->
        <div id="date-picker-container"></div>
        <br />
        <!-- Combo Box -->
        <div class="dropdown-container" *ngIf="!isTabletOrSmaller && viewType == 'day'">
          <button class="dropdown-btn" (click)="toggleDropdown()">Staff</button>
          <div id="staffDropdown" class="dropdown-content" [class.show]="dropdownOpen">
            <ng-container *ngIf="!isTabletOrSmaller">
              <label *ngFor="let resource of resourceFilter">
                <input type="checkbox"
                       [(ngModel)]="resource.selected"
                       (change)="onCheckboxChange(resource.id, $event)">
                {{ resource.name }}
              </label>
            </ng-container>
            <ng-container *ngIf="isTabletOrSmaller">
              <label *ngFor="let resource of resourceFilter">
                <input type="radio"
                       name="resource"
                       [(ngModel)]="selectedResource"
                       [value]="resource.id"
                       (change)="onRadioGroupChange(resource.id)">
                {{ resource.name }}
              </label>
            </ng-container>
            <hr>
            <label>
              <input type="checkbox" [(ngModel)]="selectAllChecked" (change)="selectAll($event)">
              <strong>Select All</strong>
            </label>
            <hr>
            <button *ngIf="!isTabletOrSmaller" class="clear-btn" (click)="clearFilters()">Clear Filter</button>
          </div>
        </div>
        <div class="dropdown-container" *ngIf="isTabletOrSmaller || viewType != 'day'">
          <button class="dropdown-btn" (click)="toggleDropdown()">Staff</button>
          <div id="staffDropdown" class="dropdown-content" [class.show]="dropdownOpen">
            <label *ngFor="let resource of resourceFilter">
              <input type="radio"
                     name="SingleResource"
                     [(ngModel)]="selectedResource"
                     [value]="resource.id"
                     (change)="onRadioGroupChange(resource.id)">
              {{ resource.name }}
            </label>
          </div>
        </div>
      </div>
      <div class="zoom-wrapper" [ngClass]="{'zoom-wrapper-zoomed': zoomLevel === 0.7}" *ngIf="viewType == 'day'">
        <bryntum-scheduler #scheduler
                           [width]="'100vw'"
                           [height]="'85vh'"
                           [startDate]="schedulerProps.startDate"
                           [endDate]="schedulerProps.endDate"
                           [eventStyle]="schedulerProps.eventStyle"
                           [resources]="resources"
                           [events]="events"
                           [mode]="'vertical'"
                           [viewPreset]="schedulerProps.viewPreset"
                           [barMargin]="schedulerProps.barMargin"
                           [rowHeight]="schedulerProps.rowHeight"
                           [resourceImagePath]="schedulerProps.resourceImagePath"
                           [timeAxis]="schedulerProps.timeAxis"
                           [eventRenderer]="schedulerProps.eventRenderer"
                           [scheduleMenuFeature]="schedulerProps.scheduleMenuFeature"
                           [eventMenuFeature]="schedulerProps.eventMenu"
                           [eventEditFeature]="schedulerProps.eventEditFeature"
                           [eventDragFeature]="schedulerProps.eventDragFeature"
                           [eventResizeFeature]="schedulerProps.eventResizeFeature"
                           [eventTooltipFeature]="schedulerProps.eventTooltipFeature"
                           [createEventOnDblClick]="schedulerProps.createEventOnDblClick"
                           [eventDragCreateFeature]="schedulerProps.eventDragCreate"
                           [regionResizeFeature]="schedulerProps.regionResizeFeature"
                           [timeAxisHeaderMenuFeature]="schedulerProps.timeAxisHeaderMenuFeature"
                           [resourceColumns]="schedulerProps.resourceColumns"
                           [subGridConfigs]="schedulerProps.subGridConfigs"
                           [eventLayout]="'pack'"
                           (onEventDblClick)="eventDblClickHandler($event)">
        </bryntum-scheduler>
      </div>
      <!-- Bryntum Scheduler -->
      <div *ngIf="viewType == 'week'" class="week-view-container">
        <context-menu #basicMenu menuClass="context-menu-custom-style">
          <ng-template contextMenuItem (execute)="addAppointment($event.value)">
            Add Appointment
          </ng-template>
          <ng-template contextMenuItem [divider]="true">Test</ng-template>
          <ng-template contextMenuItem (execute)="addLeave($event.value)">
            Leave
          </ng-template>
          <ng-template contextMenuItem [divider]="true"></ng-template>
          <ng-template contextMenuItem (execute)="addMeeting($event.value)">
            Meeting
          </ng-template>
          <ng-template contextMenuItem [divider]="true"></ng-template>
          <ng-template contextMenuItem (execute)="addTraining($event.value)">
            Training
          </ng-template>
          <ng-template contextMenuItem [divider]="true"></ng-template>
          <ng-template contextMenuItem (execute)="addAdministration($event.value)">
            Administration
          </ng-template>
          <ng-template contextMenuItem [divider]="true"></ng-template>
          <ng-template contextMenuItem (execute)="addLunch($event.value)">
            Lunch
          </ng-template>
        </context-menu>
        <mwl-calendar-week-view style="width: 100%;"
                                [viewDate]="viewDate"
                                [events]="eventsCalendar"
                                [refresh]="refresh"
                                [dayStartHour]="7"
                                [dayEndHour]="18"
                                [hourSegments]="2"
                                [hourSegmentHeight]="70"
                                [eventTemplate]="customEventTemplate"
                                [weekStartsOn]="weekStartsOn"
                                [hourSegmentTemplate]="weekViewHourSegment"
                                [headerTemplate]="weekHeaderTemplate"
                                (eventClicked)="eventClicked($event)"
                                [currentTimeMarkerTemplate]="currentTimeMarkerTemplate">
        </mwl-calendar-week-view>
        <ng-template #currentTimeMarkerTemplate
                     let-columnDate="columnDate"
                     let-dayStartHour="dayStartHour"
                     let-dayStartMinute="dayStartMinute"
                     let-dayEndHour="dayEndHour"
                     let-dayEndMinute="dayEndMinute"
                     let-isVisible="isVisible"
                     let-topPx="topPx">
          <div class="cal-current-time-marker"
               *ngIf="isVisible && showMarker"
               [style.top.px]="topPx"></div>
        </ng-template>
        <ng-template #weekHeaderTemplate
                     let-days="days"
                     let-locale="locale"
                     let-dayHeaderClicked="dayHeaderClicked">
          <div class="cal-day-headers">
            <div class="cal-header"
                 *ngFor="let day of days"
                 [class.cal-past]="day.isPast"
                 [class.cal-today]="day.isToday"
                 [class.cal-future]="day.isFuture"
                 [class.cal-weekend]="day.isWeekend"
                 (click)="dayHeaderClicked.emit({day: day})"
                 [contextMenu]="basicMenu"
                 [contextMenuValue]="day.date"
                 (contextmenu)="$event.preventDefault()">
              <b>{{ day.date | calendarDate:'weekViewColumnHeader':locale }}</b><br />
              <span>{{ day.date | calendarDate:'weekViewColumnSubHeader':locale }}</span>
            </div>
          </div>
        </ng-template>
        <ng-template #weekViewHourSegment
                     let-segment="segment"
                     let-locale="locale"
                     let-segmentHeight="segmentHeight"
                     let-isTimeLabel="isTimeLabel">
          <div class="cal-hour-segment"
               [style.height.px]="segmentHeight"
               [class.cal-hour-start]="segment.isStart"
               [class.cal-after-hour-start]="!segment.isStart"
               [ngClass]="segment.cssClass"
               [contextMenu]="basicMenu"
               [contextMenuValue]="segment.date"
               (contextmenu)="$event.preventDefault()">
            <div class="cal-time" *ngIf="isTimeLabel">
              {{ segment.date | calendarDate: 'weekViewHour':locale }}
            </div>
          </div>
        </ng-template>
        <ng-template #customEventTemplate let-weekEvent="weekEvent" let-locale="locale">
          <div class="custom-event-container" [style.backgroundColor]="weekEvent.event.color?.primary || '#d1e8ff'" (dblclick)="eventClicked(weekEvent)" *ngIf="weekEvent.event.meta?.IsEmployeeMeeting">
            <div style="display: flex; justify-content: center; align-items: center; width: 100%; padding: 2px 0;">
              <div style="color: black; background-color: white; padding: 3px 8px; font-size: 10px; margin-bottom: 5px;">
                {{ weekEvent.event.start | date: 'shortTime' }} - {{ weekEvent.event.end | date: 'shortTime' }}
              </div>
            </div>
            <span style="font-weight: bold; color: black; justify-content: left; padding: 5px 0">{{weekEvent.event.meta?.ServiceName}}</span>
            <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
            <span style="font-weight: bold; color: black; justify-content: left; padding: 5px 0">{{weekEvent.event.meta?.Location}}</span>
            <span style="display: block; height: 1px; background-color: #000; width: 100%;"></span>
          </div>
          <div class="custom-event-container" [style.backgroundColor]="weekEvent.event.color?.primary || '#d1e8ff'" (dblclick)="eventClicked(weekEvent)" *ngIf="!weekEvent.event.meta?.IsEmployeeMeeting">
            <!-- Icons or other details -->
            <div class="custom-event-icons">
              <ng-container *ngIf="weekEvent.event.meta?.HasArrived == true">
                <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_440_5264)">
                    <path d="M5.24727 8.15283L6.92675 8.15283L6.92675 12.6244L5.24727 12.6244C5.15329 12.6244 5.06317 12.5871 4.99672 12.5206C4.93027 12.4541 4.89294 12.364 4.89294 12.2701L4.89294 8.50715C4.89294 8.41318 4.93027 8.32306 4.99672 8.25661C5.06317 8.19017 5.15329 8.15283 5.24727 8.15283Z" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.92676 8.15256L8.72671 5.27547C8.79646 5.16175 8.89449 5.06804 9.01122 5.00346C9.12796 4.93888 9.25944 4.90565 9.39284 4.90698C9.4979 4.90318 9.60266 4.92049 9.70091 4.95788C9.79918 4.99526 9.88894 5.05196 9.96492 5.12463C10.0409 5.1973 10.1015 5.28446 10.1432 5.38097C10.185 5.47747 10.2069 5.58135 10.2078 5.68648L10.2078 7.74863L13.3187 7.74863C13.4337 7.75236 13.5465 7.78038 13.6499 7.83085C13.7532 7.88131 13.8447 7.95308 13.9184 8.04143C13.992 8.12979 14.0461 8.23273 14.0771 8.34348C14.1081 8.45424 14.1153 8.57031 14.0982 8.68404L13.5313 12.3406C13.5072 12.5361 13.4124 12.7159 13.2649 12.8464C13.1175 12.9769 12.9274 13.0491 12.7305 13.0493L8.08184 13.0493C7.86055 13.0501 7.64213 12.9992 7.44406 12.9004L6.93384 12.6454" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.92676 8.15266L6.92676 12.6242" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_440_5264">
                      <rect width="10" height="10" fill="white" transform="translate(4.5 4)" />
                    </clipPath>
                  </defs>
                </svg>
              </ng-container>
              <ng-container *ngIf="weekEvent.event.meta?.HasArrived != true">
                <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="ThumbsupClick(weekEvent)" style="z-index: 2;">
                  <g clip-path="url(#clip0_440_5264)">
                    <path d="M5.24727 8.15283L6.92675 8.15283L6.92675 12.6244L5.24727 12.6244C5.15329 12.6244 5.06317 12.5871 4.99672 12.5206C4.93027 12.4541 4.89294 12.364 4.89294 12.2701L4.89294 8.50715C4.89294 8.41318 4.93027 8.32306 4.99672 8.25661C5.06317 8.19017 5.15329 8.15283 5.24727 8.15283Z" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.92676 8.15256L8.72671 5.27547C8.79646 5.16175 8.89449 5.06804 9.01122 5.00346C9.12796 4.93888 9.25944 4.90565 9.39284 4.90698C9.4979 4.90318 9.60266 4.92049 9.70091 4.95788C9.79918 4.99526 9.88894 5.05196 9.96492 5.12463C10.0409 5.1973 10.1015 5.28446 10.1432 5.38097C10.185 5.47747 10.2069 5.58135 10.2078 5.68648L10.2078 7.74863L13.3187 7.74863C13.4337 7.75236 13.5465 7.78038 13.6499 7.83085C13.7532 7.88131 13.8447 7.95308 13.9184 8.04143C13.992 8.12979 14.0461 8.23273 14.0771 8.34348C14.1081 8.45424 14.1153 8.57031 14.0982 8.68404L13.5313 12.3406C13.5072 12.5361 13.4124 12.7159 13.2649 12.8464C13.1175 12.9769 12.9274 13.0491 12.7305 13.0493L8.08184 13.0493C7.86055 13.0501 7.64213 12.9992 7.44406 12.9004L6.93384 12.6454" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.92676 8.15266L6.92676 12.6242" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_440_5264">
                      <rect width="10" height="10" fill="white" transform="translate(4.5 4)" />
                    </clipPath>
                  </defs>
                </svg>
              </ng-container>
              <div class="event-icons">
                <div class="event-icons" style="margin-top: 5px; margin-bottom: 10px; display: flex; justify-content: center;">
                  <ng-container *ngIf="weekEvent.event.meta?.Location">
                    <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.71434 5.96571C9.71491 5.88639 9.69891 5.80783 9.66742 5.73503C9.63594 5.66223 9.58965 5.59678 9.53148 5.54285L6.00006 2.28571L2.46864 5.54285C2.41048 5.59678 2.36419 5.66223 2.33271 5.73503C2.30122 5.80783 2.28524 5.88639 2.28578 5.96571V9.14285C2.28578 9.29439 2.34598 9.43976 2.45315 9.54691C2.56031 9.65405 2.70566 9.71428 2.85721 9.71428H9.14291C9.29445 9.71428 9.43982 9.65405 9.54697 9.54691C9.65417 9.43976 9.71434 9.29439 9.71434 9.14285V5.96571Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M6 9.71427V7.42856" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="weekEvent.event.meta?.AppointmentNotes">
                    <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.85718 8H9.14289" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.57141 3.71426H7.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.57141 5.14285H7.5" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M9.14289 2.28571H3.42861C3.11301 2.28571 2.85718 2.54154 2.85718 2.85713V9.14285C2.85718 9.45845 3.11301 9.71428 3.42861 9.71428H8.57146C8.88706 9.71428 9.14289 9.45845 9.14289 9.14285V2.28571Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="weekEvent.event.meta?.IsAdminCheckOut">

                    <svg width="24" height="24" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.28577 9.00012V3.00014C2.28577 2.84859 2.34597 2.70324 2.45313 2.59608C2.5603 2.48891 2.70564 2.42871 2.8572 2.42871H4.96577C5.0963 2.42491 5.2242 2.46593 5.32817 2.54495C5.43214 2.62396 5.50591 2.73621 5.5372 2.863L5.71434 3.57157H9.14291C9.29445 3.57157 9.43982 3.63177 9.54697 3.73893C9.65411 3.8461 9.71434 3.99144 9.71434 4.143V9.00012C9.71434 9.15172 9.65411 9.29703 9.54697 9.40417C9.43982 9.51137 9.29445 9.57155 9.14291 9.57155H2.8572C2.70564 9.57155 2.5603 9.51137 2.45313 9.40417C2.34597 9.29703 2.28577 9.15172 2.28577 9.00012Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M4.57153 7.14303L5.42868 7.71446L7.14296 5.42874" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </ng-container>
                  <ng-container *ngIf="weekEvent.event.meta?.IsAudiologistCheckOut">
                    <svg width="24" height="24" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_440_5238)">
                        <path d="M2.25012 2.55037C2.45183 1.97406 3.2455 0.821442 4.80646 0.821442C6.75768 0.821442 7.87753 2.47981 7.5357 4.03231C7.23931 5.3784 6.39954 5.84768 6.02906 6.16877C5.48785 6.63781 5.48801 7.02051 5.2917 7.63959C5.17817 7.99772 4.78364 8.50834 4.23407 8.57128C3.83579 8.61686 3.35609 8.42734 2.84289 7.7742" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M3.41107 3.39007C3.52794 3.10149 3.9448 2.53805 4.67739 2.59304C5.40997 2.64803 6.03899 3.39007 5.77965 4.07858C5.52031 4.76708 5.17756 4.55394 4.86579 5.01714C4.55401 5.48033 4.67047 6.4097 3.97662 6.54847C3.54439 6.63492 3.31738 6.38688 3.31738 6.38688" stroke="white" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                      <defs>
                        <clipPath id="clip0_440_5238">
                          <rect width="9" height="9" fill="white" transform="translate(0 0.5)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </ng-container>
                </div>
              </div>
              <ng-container *ngIf="weekEvent.event.meta?.HasArrived != false">
                <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="ThumbsdownClick(weekEvent)" style="z-index: 2;">
                  <g clip-path="url(#clip0_440_5265)">
                    <path d="M13.7527 9.84717L12.0732 9.84717L12.0732 5.37564L13.7527 5.37564C13.8467 5.37564 13.9368 5.41293 14.0033 5.47943C14.0697 5.54585 14.1071 5.636 14.1071 5.72993L14.1071 9.49285C14.1071 9.58682 14.0697 9.67694 14.0033 9.74339C13.9368 9.80983 13.8467 9.84717 13.7527 9.84717Z" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.0732 9.84744L10.2733 12.7245C10.2035 12.8382 10.1055 12.932 9.98878 12.9965C9.87204 13.0611 9.74056 13.0944 9.60716 13.093C9.5021 13.0968 9.39734 13.0795 9.29909 13.0421C9.20082 13.0047 9.11106 12.948 9.03508 12.8754C8.95911 12.8027 8.89847 12.7155 8.85676 12.619C8.81505 12.5225 8.79311 12.4186 8.79223 12.3135L8.79223 10.2514L5.68127 10.2514C5.56634 10.2476 5.45349 10.2196 5.35013 10.1692C5.24677 10.1187 5.15527 10.0469 5.08163 9.95857C5.00799 9.87021 4.95391 9.76727 4.92291 9.65652C4.89191 9.54576 4.8847 9.4297 4.90177 9.31596L5.4687 5.65935C5.49284 5.46392 5.58763 5.28407 5.73506 5.15357C5.88249 5.02307 6.07256 4.95092 6.26949 4.95071L10.9182 4.95071C11.1395 4.94985 11.3579 5.00078 11.5559 5.09957L12.0662 5.35464" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.0732 9.84734L12.0732 5.37578" stroke="#848789" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_440_5265">
                      <rect width="10" height="10" fill="white" transform="translate(14.5 14) rotate(-180)" />
                    </clipPath>
                  </defs>
                </svg>
              </ng-container>
              <ng-container *ngIf="weekEvent.event.meta?.HasArrived == false">
                <svg width="30" height="30" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_440_5265)">
                    <path d="M13.7527 9.84717L12.0732 9.84717L12.0732 5.37564L13.7527 5.37564C13.8467 5.37564 13.9368 5.41293 14.0033 5.47943C14.0697 5.54585 14.1071 5.636 14.1071 5.72993L14.1071 9.49285C14.1071 9.58682 14.0697 9.67694 14.0033 9.74339C13.9368 9.80983 13.8467 9.84717 13.7527 9.84717Z" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.0732 9.84744L10.2733 12.7245C10.2035 12.8382 10.1055 12.932 9.98878 12.9965C9.87204 13.0611 9.74056 13.0944 9.60716 13.093C9.5021 13.0968 9.39734 13.0795 9.29909 13.0421C9.20082 13.0047 9.11106 12.948 9.03508 12.8754C8.95911 12.8027 8.89847 12.7155 8.85676 12.619C8.81505 12.5225 8.79311 12.4186 8.79223 12.3135L8.79223 10.2514L5.68127 10.2514C5.56634 10.2476 5.45349 10.2196 5.35013 10.1692C5.24677 10.1187 5.15527 10.0469 5.08163 9.95857C5.00799 9.87021 4.95391 9.76727 4.92291 9.65652C4.89191 9.54576 4.8847 9.4297 4.90177 9.31596L5.4687 5.65935C5.49284 5.46392 5.58763 5.28407 5.73506 5.15357C5.88249 5.02307 6.07256 4.95092 6.26949 4.95071L10.9182 4.95071C11.1395 4.94985 11.3579 5.00078 11.5559 5.09957L12.0662 5.35464" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.0732 9.84734L12.0732 5.37578" stroke="#FF0000" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_440_5265">
                      <rect width="10" height="10" fill="white" transform="translate(14.5 14) rotate(-180)" />
                    </clipPath>
                  </defs>
                </svg>
              </ng-container>
            </div>
            <!-- Event Title -->
            <div class="custom-event-title">
              <strong>{{ weekEvent.event.meta?.PatientName }}</strong>
            </div>
            <!-- Event Timing -->
            <small>{{ weekEvent.event.start | date: 'shortTime' }} - {{ weekEvent.event.end | date: 'shortTime' }}</small>
          </div>
        </ng-template>
      </div>
      <div *ngIf="viewType == 'month'" class="month-view-container">
        <mwl-calendar-month-view style="width: 100%;"
                                 [viewDate]="viewDate"
                                 [events]="eventsCalendar"
                                 [refresh]="refresh"
                                 [activeDayIsOpen]="activeDayIsOpen"
                                 (dayClicked)="dayClicked($event.day)"
                                 (eventClicked)="eventClicked($event)">
        </mwl-calendar-month-view>
      </div>
      <div *ngIf="viewType == 'scheduler'" class="month-view-container">
        <mwl-day-view-scheduler [viewDate]="viewDate"
                                [events]="events"
                                [users]="resources">
        </mwl-day-view-scheduler>
      </div>
    </div>
  </div>
</div>
